<template>
    <v-combobox 
        v-model='childData'
        :label='label'
        :rules='rules'
        :items='items'
        item-text='displaytext'
        clearable
    ></v-combobox>
</template>
<script>
import ComboBoxUtil from '../utils/ComboBoxUtil'

export default {
    name: "holder-combo",
    props: {
        value: Object,
        label: String,
        rules: Array,
        items: Array,
    },
    data(){
        return {
            childData: this.value,
            nonceCount:0,
            result:null
        }
    },
    watch:{
        value(val, prev){
            if ((((val != null) || (val != undefined))
                && ((prev != null) || (prev != undefined)))
                 && (val.length === prev.length)) return
            let returnItem = ComboBoxUtil.getComboBoxModel(val, this.items,{id:-1, name:'', birthday:'', sex:'', city:'', township:'', address:'',displaytext:''})
            if (returnItem != null && returnItem.id === -1){
                returnItem.displaytext = returnItem.name
            } 
            this.childData = returnItem
        },
        childData(val){
            let returnItem = ComboBoxUtil.getComboBoxModel(val,this.items,{id:-1, name:'', birthday:'', sex:'', city:'', township:'', address:'',displaytext:''})
            if (returnItem != null && returnItem.id === -1){
                returnItem.displaytext = returnItem.name
            } 
            this.$emit('input', returnItem)
        }
    },
    methods:{
         filter(item, queryText, itemText){
            const hasValue = val => val != null ? val : '' //建立內部函式hasValue，把val用=>指到一個函式，利用三元判斷val的值。
            const text = hasValue(itemText) //呼叫內部函式
            const query = hasValue(queryText)
            return text.toString()
                .toLowerCase()
                .indexOf(query.toString().toLowerCase()) > -1
        }
    }
}
</script>
